import React, { useState } from "react";
import Loading from "../../SubDashboard/Loading/Loading";
import InputCustom from "../../UserManagment/SubUserManagment/InputCustom";
import AvatarUpload from "./AvatarUpload";
import axios from "axios";
import { Globals } from "../../../../Global";
import { uploadOrganizationAvatar } from "../../../../Api/Network";

function CreateUser({ close, onUserAdded, openError, openSuccess }) {
    const [form, setForm] = useState({
        name: "",
        family: "",
        userName: "",
        phone: "",
        pass: "",
        repPass: "",
        avatar: null
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [validationActive, setValidationActive] = useState(false);
    const [preview, setPreview] = useState(null);

    const isStrongPassword = (password) =>
        password.length >= 8 &&
        /[A-Z]/.test(password) &&
        /[a-z]/.test(password) &&
        /[0-9]/.test(password);

    const validateForm = () => {
        const newErrors = {};
        if (!form.userName.trim()) newErrors.userName = "نام کاربری نمی‌تواند خالی باشد";
        if (!form.pass) newErrors.pass = "رمز عبور الزامی است";
        else if (!isStrongPassword(form.pass))
            newErrors.pass = "رمز عبور باید حداقل ۸ کاراکتر، شامل حروف بزرگ، کوچک و عدد باشد";
        if (form.pass !== form.repPass) newErrors.repPass = "رمز عبور و تکرار آن یکسان نیستند";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (field) => (value) => {
        setForm((prev) => ({ ...prev, [field]: value }));

        if (!validationActive) return;

        if (field === "userName") {
            setErrors((prev) => ({
                ...prev,
                userName: value.trim() ? "" : "نام کاربری الزامی است"
            }));
        }

        if (field === "pass") {
            setErrors((prev) => ({
                ...prev,
                pass: isStrongPassword(value) ? "" : "رمز عبور ضعیف است"
            }));
        }

        if (field === "repPass") {
            setErrors((prev) => ({
                ...prev,
                repPass: value !== form.pass ? "عدم تطابق رمز عبور" : ""
            }));
        }
    };

    const handleSubmit = () => {
        setValidationActive(true);
        if (!validateForm()) return;

        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            openSuccess("کاربر با موفقیت ایجاد شد");
            onUserAdded();
            handleClose();
        }, 1000);
    };

    const handleClose = () => {
        setErrors({});
        setValidationActive(false);
        close(false);
    };

    const fields = [
        { title: "نام", field: "name" },
        { title: "نام خانوادگی", field: "family" },
        { title: "نام کاربری", field: "userName" },
        { title: "شماره موبایل", field: "phone" },
        { title: "رمز عبور", field: "pass" },
        { title: "تکرار رمز عبور", field: "repPass" }
    ];

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setForm((prev) => ({ ...prev, avatar: file }));
        setPreview(URL.createObjectURL(file));
    };

    const handleUploadAvatar = async () => {
        if (!form.avatar) {
            openError("هیچ تصویری انتخاب نشده است");
            return;
        }
        try {
            await uploadOrganizationAvatar(
                Globals.token,
                form.avatar,
                "1011762244120769", // id
                "https://yahoo.com"
            );

            openSuccess("تصویر با موفقیت ارسال شد");
        } catch (error) {
            console.error(error);
            openError("خطا در ارسال تصویر");
        }
    };

    return (
        <>
            <div
                className="modal-overlay fixed top-0 left-0 w-screen h-screen bg-black opacity-40"
                onClick={handleClose}
            ></div>
            <div className="fixed top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-primary-100 rounded-lg px-14 py-14">
                <div className="flex items-center justify-between mb-8">
                    <img
                        src="/image/icon/close.png"
                        className="w-5 cursor-pointer"
                        onClick={handleClose}
                    />
                    <p className="text-right text-lg font-bold text-slate-800">ایجاد کاربر</p>
                </div>

                <AvatarUpload preview={preview} onImageChange={handleImageChange} />

                {fields.map((f) => (
                    <div className="mb-4" key={f.field}>
                        <InputCustom
                            title={f.title}
                            value={form[f.field]}
                            onChange={handleChange(f.field)}
                            error={errors[f.field]}
                        />
                    </div>
                ))}

                <div className="flex flex-row-reverse justify-between mt-10 gap-4 flex-wrap">
                    <button
                        onClick={handleSubmit}
                        className="bg-primary-500 flex-1 rounded-lg text-white p-2"
                    >
                        ثبت
                    </button>
                    <button
                        onClick={handleClose}
                        className="border border-primary-500 flex-1 rounded-lg text-primary-500 p-2"
                    >
                        لغو
                    </button>
                    {/* <button
                        type="button"
                        onClick={handleUploadAvatar}
                        className="bg-green-500 text-white rounded-lg px-4 py-2 mt-4"
                    >
                        تست ارسال تصویر
                    </button> */}
                </div>
            </div>
            {loading && <Loading />}
        </>
    );
}

export default CreateUser;